
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/examples/form-data",
      function () {
        return require("private-next-pages/examples/form-data.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/examples/form-data"])
      });
    }
  